var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Http } from '@angular/http';
import { KeycloakService } from '../../services/keycloak.service';
import { CommonService } from '../../services/common.service';
import { CedulaService } from '../../services/cedula.service';
import { CedulaFilterComponent } from './cedula-filter.component';
import { SearchService } from '../../services/search.service';
import { ActuacionPopupComponent } from '../actuacion/actuacion-popup.component';
import { SharedService } from '../../services/shared.service';
var CedulaComponent = (function () {
    function CedulaComponent(_http, route, _service, _cedService, _comService) {
        this._http = _http;
        this.route = route;
        this._service = _service;
        this._cedService = _cedService;
        this._comService = _comService;
        this.activateList = false;
        this.curPage = 0;
        this.cantPages = 0;
        this.searchFilter = { fecha_desde: "", org_id: 0, caratula: "", usrCod: KeycloakService.getLoggedUser(), page: 0, size: 10 };
        this.cantResul = 10;
        this.muestraPaginas = true;
        this.instanceId = Math.floor(Math.random() * 1000000);
    }
    CedulaComponent.prototype.ngOnInit = function () {
        var _this = this;
        var date = new Date();
        //this.searchFilter.fecha_desde = ('0' + date.getDate()).slice(-2) + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + (date.getFullYear() - 2 );
        this._subscription = CedulaFilterComponent.observable().subscribe(function (item) { return _this.searchAction(item); });
        //this._subscription = SearchComponent.observable().subscribe(item => this.searchActionRap(item));
        this.route.queryParams.subscribe(function (param) {
            if (param["q"]) {
                var filter = JSON.parse(atob(param["q"]));
                _this.searchActionRap(filter);
            }
            else {
                //console.log("FILTROS -> q = " + JSON.stringify(this.searchFilter));
                _this.searchAction(_this.searchFilter);
            }
        });
    };
    CedulaComponent.prototype.ngOnDestroy = function () {
        // prevent memory leak when component is destroyed
        this._subscription.unsubscribe();
    };
    CedulaComponent.prototype.prevPage = function () {
        var _this = this;
        if (this.curPage > 0) {
            this.curPage = this.curPage - 1;
            this._cedService.findCedulasPage(this.armarString(), this.curPage, 5).subscribe(function (response) {
                _this.cedulasList = response;
                _this.pages = new Array(Math.ceil(_this.cedulasList.total / _this.cantResul)).map(function (x, i) { return i; });
            });
            //console.log("<< " + this.curPage);
        }
    };
    CedulaComponent.prototype.goToPage = function (index) {
        var _this = this;
        this.curPage = index;
        this._cedService.findCedulasPage(this.armarString(), index + 1, 5).subscribe(function (response) {
            _this.cedulasList = response;
            _this.pages = new Array(Math.ceil(_this.cedulasList.total / _this.cantResul)).map(function (x, i) { return i; });
            _this.curPage = index;
            //console.log(">> " + this.curPage);
        });
    };
    CedulaComponent.prototype.nextPage = function () {
        var _this = this;
        if (this.curPage < this.pages.length - 1) {
            this.curPage = this.curPage + 1;
            this._cedService.findCedulasPage(this.armarString(), this.curPage, 5).subscribe(function (response) {
                _this.cedulasList = response;
                _this.pages = new Array(Math.ceil(_this.cedulasList.total / _this.cantResul)).map(function (x, i) { return i; });
                //console.log(">> " + this.curPage);
            });
        }
    };
    CedulaComponent.prototype.searchAction = function (filter) {
        var _this = this;
        this.hideErrorMsg();
        this.searchFilter = filter;
        this.muestraPaginas = true;
        this.curPage = 0;
        //console.log("FILTROS -> q = " + JSON.stringify(this.searchFilter));
        this._cedService.findCedulasPage(this.armarString(), 1, 5).subscribe(function (response) {
            _this.cedulasList = response;
            _this.pages = new Array(Math.ceil(_this.cedulasList.total / _this.cantResul)).map(function (x, i) { return i; });
            _this.curPage = 0;
            _this.cantPages = _this.pages.length - 1;
            _this.activateList = (_this.cedulasList.total > 0);
            if (_this.cedulasList.total == 0) {
                _this.showErrorMessage("No se han encontrado resultados");
            }
            _this._comService.emitBlocking(false);
        });
    };
    CedulaComponent.prototype.searchActionRap = function (fil) {
        var _this = this;
        this.hideErrorMsg();
        if (fil.query != "") {
            this.filter = fil;
            this.searchFilter.fecha_desde = fil.query;
            this.searchFilter.size = 50;
            this.searchFilter.page = 0;
            //console.log("RAPIDA -> q = " + JSON.stringify(this.searchFilter));
            this._cedService.findCedulasPage(btoa(SharedService.unescape(encodeURIComponent(JSON.stringify(this.searchFilter)))), 1).subscribe(function (response) {
                _this.cedulasList = response;
                _this.muestraPaginas = false;
                _this.curPage = 0;
                _this.activateList = (_this.cedulasList.total > 0);
                if (_this.cedulasList.total == 0) {
                    _this.showErrorMessage("No se han encontrado resultados");
                }
            });
            this._comService.emitBlocking(false);
        }
    };
    CedulaComponent.prototype.armarString = function () {
        this.searchFilter.page = this.curPage;
        this.searchFilter.size = this.cantResul;
        // console.log("-> q = " + JSON.stringify(this.searchFilter));
        // console.log("search q --> " + btoa(JSON.stringify(this.searchFilter)));
        this.strParam = btoa(SharedService.unescape(encodeURIComponent(JSON.stringify(this.searchFilter))));
        return this.strParam;
    };
    CedulaComponent.prototype.showErrorMessage = function (msg) {
        this.ErrorMsg = msg;
        this.ErrorMessageIsVisible = true;
    };
    CedulaComponent.prototype.hideErrorMsg = function () {
        this.ErrorMsg = "";
        this.ErrorMessageIsVisible = false;
    };
    CedulaComponent.prototype.openAct = function (id) {
        this.actPopup.loadAct(id);
    };
    return CedulaComponent;
}());
__decorate([
    ViewChild(ActuacionPopupComponent),
    __metadata("design:type", ActuacionPopupComponent)
], CedulaComponent.prototype, "actPopup", void 0);
CedulaComponent = __decorate([
    Component({
        //selector: 'despacho-diario-component',
        moduleId: module.id,
        selector: 'my-app',
        templateUrl: 'cedula.component.html'
    }),
    __metadata("design:paramtypes", [Http,
        ActivatedRoute,
        SearchService,
        CedulaService,
        CommonService])
], CedulaComponent);
export { CedulaComponent };
//# sourceMappingURL=cedula.component.js.map